import Toggle from 'components/ReusableComponents/Toggle'
import { useState } from 'react'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import styles from './EditTASettingsDialog.module.scss'

const urlRegex = /^(http|https)?:\/\/\S+/i

const EditTASettingsDialog = ({
  reviewTripAdvisorMinStars,
  alternateReviewLink,
  handleClose,
  handleConfirm
}) => {
  const [minRating, setMinRating] = useState(reviewTripAdvisorMinStars)

  const [customReviewLink, setCustomReviewLink] = useState(alternateReviewLink)

  const [isCustomReviewEnabled, setIsCustomReviewEnabled] = useState(
    !!alternateReviewLink
  )

  const isCustomReviewLinkValid = customReviewLink
    ? !!customReviewLink.match(urlRegex)
    : false

  function handleChangeCustomReviewToggle(e) {
    setIsCustomReviewEnabled(e.target.checked)
    if (!e.target.check) {
      setCustomReviewLink(null)
    }
  }

  return (
    <ConfirmationDialog
      title="Review settings"
      theme="blacklist"
      positiveMessage="Save changes"
      onClose={handleClose}
      onConfirm={() =>
        handleConfirm({
          reviewTripAdvisorMinStars: minRating,
          alternateReviewLink: customReviewLink
        })
      }
      isButtonDisabled={
        !(
          minRating <= 5 &&
          minRating >= 0.5 &&
          minRating % 0.5 === 0 &&
          (isCustomReviewEnabled ? isCustomReviewLinkValid : true)
        )
      }
    >
      <div className={styles.container}>
        <TextInput
          label=" Min. rating for TA review"
          value={minRating}
          type="number"
          step={0.5}
          max={5}
          min={0.5}
          onChange={e => setMinRating(e.target.value)}
        />
        <div className={styles.customReviewLinkHolder}>
          <Toggle
            label="Use custom review link"
            checked={isCustomReviewEnabled}
            handleChange={handleChangeCustomReviewToggle}
            className={styles.customReviewLinkToggle}
          />
          {isCustomReviewEnabled && (
            <div>
              <TextInput
                className={styles.customReviewLinkInput}
                label="Custom review link"
                autoFocus
                value={customReviewLink || ''}
                onChange={e => setCustomReviewLink(e.target.value)}
                valid={isCustomReviewLinkValid}
              />
              {customReviewLink && !isCustomReviewLinkValid && (
                <p className={styles.customRevieLinkError}>
                  Enter a valid link starting with http or https
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default EditTASettingsDialog
